// extracted by mini-css-extract-plugin
export var cookiesSection = "d6_JG";
export var cookiesSection__btn = "d6_JK";
export var cookiesSection__link = "d6_JJ";
export var cookiesSection__text = "d6_JH";
export var cookiesSection__wrapper = "d6_JF";